import { usePage } from '@inertiajs/react'
import SiteForm from './SiteForm'
import { t } from '@/shared/lib/i18n'
import { sitesPath, organizationPath } from '@/shared/lib/routes'
import { useBreadcrumbs } from '@/shared/lib/breadcrumbs-context'
import type { WeekdaySchedule } from '@/shared/ui/weekly-schedule-grid'

interface TimezoneOption {
  value: number
  label: string
}

interface CountryOption {
  value: number
  label: string
  phoneCode: string
}

interface Props {
  timezones: TimezoneOption[]
  countries: CountryOption[]
  customDaySchedule: WeekdaySchedule
  parentDaySchedule: WeekdaySchedule
  [key: string]: unknown
}

const NewSitePage = () => {
  const { timezones, countries, customDaySchedule, parentDaySchedule } = usePage<Props>().props

  useBreadcrumbs([
    { label: t('nav.administration'), href: organizationPath() },
    { label: t('nav.sites'), href: sitesPath() },
    { label: t('organization.sites.newSite') },
  ])

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">{t('organization.sites.newSite')}</h1>
      <SiteForm
        timezones={timezones}
        countries={countries}
        customDaySchedule={customDaySchedule}
        parentDaySchedule={parentDaySchedule}
        submitUrl={sitesPath()}
        submitMethod="post"
      />
    </div>
  )
}

export default NewSitePage
